import styled from "styled-components";

const Details = styled.div`
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  color: #222;
  margin-top: -92px;
  width: 350px;
  margin-left: -175px;

  @media (max-width: 1199px) {
    width: 340px;
    margin-left: -170px;
  }
  @media (max-width: 991.98px) {
    width: 300px;
    margin-left: -150px;
  }
  @media (max-width: 767px) {
    width: 240px;
    margin-left: -120px;
    margin-top: -60px;
  }
  @media (max-width: 575px) {
    width: 305px;
    margin-left: -153px;
    margin-top: 10px;
    position: relative;
    background: #fff;
    padding: 20px;
    border-bottom: 3px solid #000;
  }
`;
export default Details;
